import EnumSignLevel from "./gen/qsign/types/EnumSignLevel";
const labels = {
  [EnumSignLevel.QUALIFIED]: "Kvalifikovaný",
  [EnumSignLevel.GUARANTEED]: "Zaručený",
};
export function getCaption(source) {
  const caption = labels[source];
  return caption ? caption : "[" + source + "]";
}
